// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__36-Qp","cell":"ColumnAccessor_cell__22RQE","firstCellAccent":"ColumnAccessor_firstCellAccent__2jatT"};